const wenv = (key: string) => window?.env?.[key];
const penv = (key: string) => process.env[`REACT_APP_${key}`] || process.env[key];
// @ts-nocheck
export const config = {
  baseUrl: wenv('API_URL') || penv('API_URL'),
  suffixApi: '/api',
  versionApi: '/v1',
  paymentTransactionsPageSize: 10,
  homeownersPageSize: 10,
  lockboxFilesPageSize: 10,
  onboardingPageSize: 10,
  taxFormsPageSize: 50,
  welcomeRoute: '/Home',
  domain: wenv('AUTH_DOMAIN') || penv('AUTH_DOMAIN') || '',
  clientId: wenv('CLIENT_ID') || penv('AUTH_CLIENT_ID') || penv('CLIENT_ID') || '',
  audience: wenv('AUTH_AUDIENCE') || penv('AUTH_AUDIENCE') || '',
  redirectUri: window.location.origin + process.env.PUBLIC_URL,
  instrumentationKey: wenv('INSTRUMENTATION_KEY') || penv('INSTRUMENTATION_KEY') || '',
  stripeKey:  wenv('STRIPE_KEY') || penv('STRIPE_KEY') || 'pk_test_PZRvQdBDrkYd5BYc1HGhcprd00yk0IkfaB',
  frontstepsPaymentsUrl: penv('FRONTSTEPS_PAYMENTS_URL') || 'https://frontsteps.com/payments-automations?utm_source=fs_products&utm_medium=suite_manager&utm_campaign=payments',
  teamEmails: penv('RELEASE_NOTES_PAYMENTS_TEAM_EMAILS') || 'kguttula@frontsteps.com,mgalvez@frontsteps.com,kelvin.willis@frontsteps.com,oenriquez@frontsteps.com,abradshaw@frontsteps.com',
  appLinks: {
    fsc: wenv('APP_LINK_FSC') || penv('APP_LINK_FSC') || '',
    dwelling: wenv('APP_LINK_DWELLING') || penv('APP_LINK_DWELLING') || '',
    payments: wenv('APP_LINK_PAYMENTS') || penv('APP_LINK_PAYMENTS') || '',
    caliber: wenv('APP_LINK_CALIBER') || penv('APP_LINK_CALIBER') || '',
    suiteManager: wenv('APP_LINK_SUITE_MANAGER') || penv('APP_LINK_SUITE_MANAGER') || '',
    verifiedAmbassadors: wenv('APP_LINK_VERIFIED_AMBASSADORS') || penv('APP_LINK_VERIFIED_AMBASSADORS') || '',
    globalNav: wenv('APP_LINK_GLOBAL_NAV') || penv('APP_LINK_GLOBAL_NAV') || ''
  },
  claspoId: wenv('CLASPO_ID') || penv('CLASPO_ID'),
};
